<script setup>
import { storeToRefs } from 'pinia'
import { langUrl } from '@/helpers'
import { useLangStore } from '@/stores/app/lang'
import { useMenuStore } from '@/stores/gallery/menu'
import { watch, computed } from 'vue'

const { lang } = storeToRefs(useLangStore())
const { category } = storeToRefs(useMenuStore())

const imageHead = computed(() => {
  switch (category.value) {
    case 4:
      return langUrl('/images/main/th/head-monk-bags.png')
    case 5:
      return langUrl('/images/main/th/head-prostrating-cloths.png')
    default:
      return langUrl('/images/main/th/head-talipot-fans.png')
  }
})

// State -----------------------------------------

// Getters ---------------------------------------

// Methods ---------------------------------------

// Events ----------------------------------------

// Main Setup ------------------------------------

// -----------------------------------------------
</script>

<template>
  <transition name="fade-lang">
    <div class="main-head" :key="imageHead" :lang="lang">
      <img :src="imageHead" />
    </div>
  </transition>
</template>

<style scoped>
.main-head {
  position: absolute;
}
</style>
